import React, { useLayoutEffect, useState } from 'react';
import Anchor from 'antd/es/anchor';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';

import { configActions } from 'models/config';
import { PhoneIcon } from 'components/icons/phone-icon';
import { PathCreator, RoutePaths } from 'routing/constants';
import { useAppDispatch, useAppSelector } from 'utils/hooks';
import { LocationIcon } from 'components/icons/location-icon';
import { getConfigLayoutSelector } from 'models/config/selectors';
import { getCourseAddressSelector, getCourseSelector } from 'models/course/selectors';

import {
  CourseImage,
  CourseInformationBlock,
  CourseInformationContainer,
  CourseInformationItem,
  ExpandButton
} from './elements';


const util = new PhoneNumberUtil();

const getFormattedPhone = (phoneNumber: string) => {
  try {
    const parsedPhone = util.parseAndKeepRawInput(phoneNumber);
    return util.format(parsedPhone, PhoneNumberFormat.INTERNATIONAL)
  } catch (e) {
    return phoneNumber;
  }
}

interface ICourseInformation {
  dependencies?: any[];
}

export const CourseInformation = ({ dependencies = [] }: ICourseInformation) => {
  const dispatch = useAppDispatch();
  const courseData = useAppSelector(getCourseSelector);
  const address = useAppSelector(getCourseAddressSelector);
  const configLayout = useAppSelector(getConfigLayoutSelector);
  const breakpoints = useBreakpoint();
  const [height, setHeight] = useState(230);

  const phone = courseData?.contactPhone?.replace('+1', '');
  const golfImage = courseData?.imageUrl || '';

  const onExpandToggleClick = () => {
    dispatch(configActions.setLayoutAction({ shrink: !configLayout.shrink }));
  }

  useLayoutEffect(() => {
    if ((breakpoints.xxl || 1) && dependencies && (configLayout.shrink || 1)) {
      const element = document.querySelector('.header-anchor') as HTMLDivElement;
      if (element) {
        setHeight((element.clientHeight - parseFloat(getComputedStyle(element).paddingBottom)) || 230);
      }
    }
  }, [breakpoints, dependencies, configLayout.shrink]);

  return (
    <Anchor>
      <CourseInformationContainer>
        <CourseImage $shrink={configLayout.shrink} $height={height} $backgroundSrc={golfImage} alt="" />

        <CourseInformationBlock $height={height} $shrink={configLayout.shrink}>
          {address && (
            <a href={PathCreator[RoutePaths.CONTACT_US].getUrl()}>
              <CourseInformationItem className="item">
                <LocationIcon />
                {address}
              </CourseInformationItem>
            </a>
          )}

          {phone && (
            <a href={`tel:${phone}`}>
              <CourseInformationItem className="item">
                <PhoneIcon fill="white" />
                {getFormattedPhone(phone)}
              </CourseInformationItem>
            </a>
          )}
        </CourseInformationBlock>

        <ExpandButton
          onClick={onExpandToggleClick}
          icon={configLayout.shrink ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        >
          {configLayout.shrink ? 'Unfold' : 'Fold'}
        </ExpandButton>
      </CourseInformationContainer>
    </Anchor>
  );
}
